<template>
  <div> 
    <div v-if="is_super_admin">
    <div class="query-list-main">
      <el-form :inline="true" class="demo-form-inline">
        <!-- 筛选优惠券类型 -->
        <el-form-item label="优惠券类型" class="from-label" >
          <el-select v-model="couponType" clearable placeholder="请选择">
            <el-option
              v-for="item in couponTypeList"
              :key="item.coupon_type_id"
              :label="item.coupon_name"
              :value="item.coupon_type_id">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 筛选优惠券是否使用 -->
        <el-form-item label="优惠券是否使用" class="from-label" >
          <el-select v-model="couponIsUse" clearable placeholder="请选择">
            <el-option
              v-for="item in [{'name':'未使用','value':false},{'name':'已使用','value':true}]"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 搜索按钮 -->
        <el-form-item>
          <el-button type="primary" @click="couponSearch">搜索</el-button>
        </el-form-item>

      </el-form>
    </div>

    <!-- 分页表单  -->
    <div class="my-table-style">
      <el-table
      :data="couponList"
      style="width: 100%;border-color:'#606266'"
      
      :default-sort = "{prop: 'date', order: 'descending'}"
      :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
      :cell-style="{color: '#666',fontSize:'14px'}"
      border
      >
        <el-table-column
          fixed
          align="center"
          prop="coupon_id"
          label="优惠券ID"
          sortable
          >
          </el-table-column>

        <el-table-column  
          align="center"
          prop="coupon_type_name"
          label="优惠券名称"
          sortable
          >
        </el-table-column>

        <el-table-column  
          align="center"
          prop="coupon_mode"
          label="优惠券类型"
          sortable
          >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.coupon_mode == '1'">现金抵扣</el-tag>
            <el-tag v-else>折扣方式</el-tag>
          </template>
        </el-table-column>

        <el-table-column  
          align="center"
          prop="user_name"
          label="优惠券所有者"
          sortable
          >
        </el-table-column>

        <el-table-column  
          align="center"
          prop="phone_num"
          label="优惠券所有者手机号"
          sortable
          >
        </el-table-column>

        <el-table-column  
          align="center"
          prop="email"
          label="优惠券所有者邮箱"
          sortable
          >
        </el-table-column>

        <el-table-column  
          align="center"
          prop="expiration_time"
          label="过期时间"
          sortable
          >
        </el-table-column>

        <el-table-column  
          align="center"
          prop="is_used"
          label="是否使用"
          sortable
          >
          <template slot-scope="scope">

            <el-tag type="success" v-if="scope.row.is_used">已使用</el-tag>
            <el-tag v-else>未使用</el-tag>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="changeCurrent"
        :current-page="iCurrentPage"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="iMaxTotal"
        style="text-align:right; margin-top:15px"
      >
      </el-pagination>
      

    </div>





    </div>

    <div v-else>
      <div style="text-align: center;">
        <div style="margin-top: 0px;">
          <img src="../../assets/permission_denied.png">
          <div style="margin-top: 20px;">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
          </div>
        </div>
      </div>
    </div>

  </div>
  
</template>

<script>

export default {
  name: "coupon_system",
  data() {
    return {
      // 优惠券列表
      couponList: [],
      // 优惠券类型列表
      couponTypeList: [],

      // 当前选中的优惠券类型
      couponType: '',

      // 当前选中的优惠券是否使用
      couponIsUse: '',

      // 表格每页个数
      iMaxTotal: 10,

      // 当页
      iCurrentPage: 1,

      is_super_admin: false,
      
    };
  },

  mounted(){
    // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
    let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
    if (isSuperAdmin == "false") {
      this.is_super_admin = false
      return
    } else {
      this.is_super_admin = true
    }
    
    // 获取优惠券列表
    this.get_activity_coupon_list()

    // 获取当前优惠券类型
    this.get_activity_coupon_type()

  },
  
  methods: {
    // 获取优惠券列表
    async get_activity_coupon_list(){
      let d_query = {
        'page': this.iCurrentPage,
        'page_size': 10,
      }
      let res = await this.$axios.get('/api/coupon/', {params: d_query});
      // if(res.data.code == 0){
      //   this.coupon_list = res.data.data;
      // }
      this.couponList = res.data.results;
      this.iMaxTotal = res.data.count;
      console.log(this.couponList)
      console.log(res)
      console.log(11111111)
    },

    // 获取优惠券类型
    async get_activity_coupon_type(){
      let res = await this.$axios.get('/api/coupon_type/');
      this.couponTypeList = res.data;
      console.log(this.couponTypeList)
    },

    // 搜索
    async couponSearch(){
      console.log(this.couponType)
      console.log(this.couponIsUse)
      if (this.couponType === '' && this.couponIsUse === '') {
        this.$message({
          message: '请至少选择一项搜索条件',
          type: 'warning'
        });
        return;1
      }
      let d_query = {
        'page': 1,
        'page_size': 10,
        'coupon_type_id': this.couponType,
        'is_used': this.couponIsUse,
      }
      let res = await this.$axios.get('/api/coupon/', {params: d_query});
      this.$axios.get('/api/coupon/', {params: d_query})
      // this.couponList = res.data.results;
      this.couponList = res.data.results;
      this.iMaxTotal = res.data.count;
      
    },

    // 分页触发事件
    changeCurrent(val){
      this.iCurrentPage = val;
      this.get_activity_coupon_list();
    },
   
  },
  
  
};
</script>

<style>
.query-list-main {
		background-color: #fff;
		padding: 12px 16px;
		/* height: 80vh; */
	}

.my-table-style {
    /* 自适应高度 */
    height: 100%;
}
</style>


